import * as React from 'react'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import PropTypes from 'prop-types'
import * as constants from '../../../common/constants'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      minHeight: ITEM_HEIGHT * 2.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const CheckboxMultiselect = (props) => {
  const { options, defaultOption, label, handleSelect, name } = props
  const [dataValue, setValue] = React.useState(defaultOption)
  React.useEffect(() => {
    setValue(defaultOption)
  }, [defaultOption])
  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setValue(
      typeof value === 'string' ? value.split(',') : value,
    )
    handleSelect({ [name]: event.target.value })
  }

  const renderValue = (selected) => {
    const selectedValues = options.filter(option => selected.includes(option.value))
    const maxDisplayedValues = 3
    const maxSummaryLength = constants.ITEM_WIDTH / 12
  
    if (selectedValues.length === 0) {
      return ''
    } else if (selectedValues.length === 1) {
      return selectedValues[0].label
    } else {
      let summary = ''
      const displayedValues = []
      const remainingValues = []
      let totalLength = 0
      selectedValues.forEach(value => {
        const valueLength = value.label.length
        if (totalLength + valueLength <= maxSummaryLength) {
          displayedValues.push(value)
          totalLength += valueLength
        } else {
          remainingValues.push(value)
        }
      })
      const maxDisplayedCount = displayedValues.length === 0 ? 1 : Math.min(displayedValues.length, maxDisplayedValues)
      summary = displayedValues.slice(0, maxDisplayedCount).map(value => value.label).join(', ')
      if (remainingValues.length > 0) {
        const remainingCount = remainingValues.length
        summary += `...+${remainingCount}`
      }
      return summary
    }
  }
  

  return (
    <div>
      <FormControl sx={{ m: 1, width: constants.ITEM_WIDTH }}>
        <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={dataValue}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label={label} sx= {{ minHeight: 30 }}/>}
          renderValue={renderValue}
          MenuProps={MenuProps}
        >
          {options.map((item) => (
            <MenuItem
              key={item.label}
              value={item.value}
              // style={getStyles(item.value, value, theme)}
            >
              <Checkbox checked={dataValue.indexOf(item.value) > -1} />
              <ListItemText primary={item.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

CheckboxMultiselect.propTypes = {
  options: PropTypes.array,
  defaultOption: PropTypes.array,
  label: PropTypes.string,
  name: PropTypes.string,
  handleSelect: PropTypes.func,
}

export default CheckboxMultiselect
